import './DelayedPayments.css'

import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { getPackages, updatePackage } from '../../../services/packages'
import { DelayedPackagesTable } from './cmps/DelayedPackagesTable'

export const DelayedPayments = () => {
  const { loggedUser } = useSelector(state => state.user)

  const [packagesToSubtract, setpackagesToSubtract] = useState([])
  const [packagesSubtracted, setpackagesSubtracted] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
    getDelayedPackages()
  }, [])

  const getDelayedPackages = async () => {
    try {
      const pToSubtract = await getPackages({
        key: {
          index_name: 'delayStatus-index',
          primary: 'delayStatus',
          query: {
            delayStatus: '30',
          },
        },
        attr: { delayStatus: '30' },
      })
      console.log('getDelayedPackages - pToSubtract:', pToSubtract)

      const pSubtracted = await getPackages({
        key: {
          index_name: 'delayStatus-index',
          primary: 'delayStatus',
          query: {
            delayStatus: 'SUBTRACTED',
          },
        },
        attr: { delayStatus: 'SUBTRACTED' },
      })
      console.log('getDelayedPackages - pSubtracted:', pSubtracted)

      setpackagesToSubtract(pToSubtract)
      setpackagesSubtracted(pSubtracted)
    } catch (error) {
      console.log('getDelayedPackages - error:', error)
      alert(`Error! ${error.response.data?.msg}`)
    }
  }

  const changeDelayStatus = async delayedPackage => {
    setisLoading(true)
    try {
      await updatePackage(delayedPackage.id, {
        delayStatus: delayedPackage.delayStatus == '30' ? 'SUBTRACTED' : 'DONATED',
      })

      //update state
      if (delayedPackage.delayStatus == '30') {
        const updatedpackages = packagesToSubtract.filter(p => p.id !== delayedPackage.id)
        setpackagesToSubtract(updatedpackages)
      } else {
        const updatedpackages = packagesSubtracted.filter(p => p.id !== delayedPackage.id)
        setpackagesSubtracted(updatedpackages)
      }
    } catch (error) {
      console.log('DelayedPayments - error', error)
      alert(`Error! ${error.response.data?.msg}`)
    } finally {
      setisLoading(false)
    }
  }

  return (
    <section className='delayed-payments-container'>
      <h3 className='main-title'>Delayed Payments</h3>

      <h4 className='main-title'>Packages to subtract</h4>
      <DelayedPackagesTable delayedPackages={packagesToSubtract} changeDelayStatus={changeDelayStatus} isLoading={isLoading} />

      {loggedUser.permissions['Admin'] && (
        <>
          <h4 className='main-title'>Packages to donate</h4>
          <DelayedPackagesTable delayedPackages={packagesSubtracted} changeDelayStatus={changeDelayStatus} isLoading={isLoading} />
        </>
      )}
    </section>
  )
}
